'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _Loading = require('../Loading');

var _Loading2 = _interopRequireDefault(_Loading);

var _FieldSelect = require('./FieldSelect');

var _FieldSelect2 = _interopRequireDefault(_FieldSelect);

var _QueryEditor = require('./QueryEditor');

var _QueryEditor2 = _interopRequireDefault(_QueryEditor);

var _DocsTable = require('./DocsTable');

var _DocsTable2 = _interopRequireDefault(_DocsTable);

var _style = require('./style');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// if create function on every render
// callback will be called every render
var focusWhenMounted = function focusWhenMounted(el) {
  if (el) el.focus();
};

var autoFocus = function autoFocus(Component) {
  return function (props) {
    return _react2.default.createElement(
      'span',
      { ref: focusWhenMounted, tabIndex: '0' },
      _react2.default.createElement(Component, props)
    );
  };
};

function ToolButtons(_ref) {
  var downloadQuery = _ref.downloadQuery;

  return _react2.default.createElement(
    'button',
    {
      className: 'btn btn-primary form-control',
      onClick: downloadQuery
    },
    '\u4E0B\u8F09\u7BE9\u9078\u8CC7\u6599'
  );
}

ToolButtons.propTypes = {
  downloadQuery: _propTypes.func.isRequired
};

var DocList = function DocList(props) {
  var schema = props.schema,
      page = props.page,
      ui = props.ui,
      isLoading = props.isLoading,
      fields = props.fields,
      setFields = props.setFields,
      query = props.query,
      setQuery = props.setQuery,
      docs = props.docs,
      addQueryField = props.addQueryField;


  return _react2.default.createElement(
    'div',
    null,
    isLoading ? _react2.default.createElement(_Loading2.default, null) : null,
    _react2.default.createElement(
      'div',
      { className: _style2.default.list },
      _react2.default.createElement(
        'h3',
        { className: _style2.default.pageTitle },
        ui.title
      ),
      _react2.default.createElement(
        'div',
        { className: _style2.default.search },
        _react2.default.createElement(_FieldSelect2.default, {
          value: fields, onChange: setFields, setting: ui.fields,
          schema: schema, style: _style2.default
        }),
        _react2.default.createElement(_QueryEditor2.default, {
          value: query, onChange: setQuery, setting: ui.query,
          fields: fields, schema: schema
        })
      ),
      _react2.default.createElement(
        'div',
        { className: _style2.default.toolButton },
        _react2.default.createElement(ToolButtons, props)
      ),
      _react2.default.createElement(_DocsTable2.default, {
        columns: ui.columns, docs: docs, addQueryField: addQueryField, page: page, schema: schema, style: _style2.default
      })
    )
  );
};

DocList.propTypes = {
  schema: _propTypes.object.isRequired,
  ui: _propTypes.object.isRequired,
  page: _propTypes.object.isRequired,

  isLoading: _propTypes.bool.isRequired,

  fields: _propTypes.array.isRequired,
  setFields: _propTypes.func.isRequired,

  query: _propTypes.object.isRequired,
  setQuery: _propTypes.func.isRequired,

  docs: _propTypes.array.isRequired,
  addQueryField: _propTypes.func.isRequired
};

exports.default = autoFocus(DocList);


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/DocList.js
// module id = 1297
// module chunks = 0